function exclusive(widget) {
  const eventCallback = eventHandler;

  /**
   * init - Init the widget by creating the eventListener
   *
   * @return {undefined}
   */
  function init() {
    widget.summaries.on('click', eventCallback);
  }

  /**
   * eventHandler - Handle logic
   *
   * @param  {object} event The event object
   * @return {undefined}
   */
  function eventHandler(event) {
    if (event.isTrusted) {
      widget.items.each(function (index) {
        widget.close(index, false);
      });
    }
  }

  /**
   * destroy - Clear event listeners
   *
   * @return {undefined}
   */
  function destroy() {
    widget.summaries.off('click', eventCallback);
  }

  init();

  return {
    destroy
  };
}

exclusive.id = 'exclusive';

export default exclusive;
